import React, { Component } from 'react'
import { Button, Form, InputNumber, Tooltip, Checkbox } from 'antd'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import CurrencyInput from 'react-currency-input'
import { DebounceInput } from 'react-debounce-input'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'

import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'

// import PropTypes from 'prop-types'

const ButtonGroup = Button.Group

const propTypes = {}

class EstimateItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputValue: '',
      isLoading: false,
      options: _.get(this.props, 'itemActions.allItemsForAsyncTypeahead')
    }
  }

  getValueOfElement = (item, elementKey, checkboxKey, propsKey, defaultValue = '') => {
    const value = !item[checkboxKey] ? 0 : item[elementKey]
    if (value) {
      return (value * 100).toFixed(3)
    }
    return defaultValue
  }

  getOverheadValue = item => {
    return this.getValueOfElement(item, 'overhead', 'remove_default_overhead', 'defaultOverhead')
  }

  getTaxValue = item => {
    return this.getValueOfElement(item, 'tax', 'remove_default_tax', 'defaultTax', 0)
  }

  getMarkupValue = item => {
    return this.getValueOfElement(item, 'markup', 'remove_default_markup', 'defaultMarkup')
  }

  _onItemChange = value => {
    const { sectionIndex, itemIndex, handleItemChange } = this.props
    handleItemChange(value, itemIndex, sectionIndex)
  }

  _handleSearch = query => {
    this.setState({ isLoading: true })

    const searchOnItems = async query => {
      const items = _.get(this.props, 'itemActions.allItemsForTypeahead')
      const foundItems = items.filter(
        item => item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      return foundItems
    }

    searchOnItems(query).then(options => {
      this.setState({
        isLoading: false,
        options
      })
    })
  }

  _getSelectedITem = itemParam => {
    const items = _.get(this.props, 'itemActions.allItemsForTypeahead')
    const foundItem = _.find(items, item => item.value === itemParam.item_id)
    const returnVar = []
    if (foundItem) {
      returnVar.push(foundItem)
    }
    return returnVar
  }

  render() {
    const {
      item,
      handleItemColumnChange,
      handleItemDown,
      handleItemUp,
      itemIndex,
      sectionIndex,
      handleItemDelete
    } = this.props

    const { isLoading, options } = this.state
    return (
      <tr key={itemIndex}>
        <td style={{ width: '15%' }} className="text-nowrap min-width-input">
          <Tooltip title={item ? item.name : ''}>
            <div>
              <AsyncTypeahead
                key={`${itemIndex}${item.name}`}
                id={`item-${itemIndex}`}
                delay={200}
                labelKey="text"
                isLoading={isLoading}
                options={options}
                minLength={1}
                onSearch={this._handleSearch}
                placeholder="Search for some Item..."
                defaultSelected={this._getSelectedITem(item)}
                onChange={selected => {
                  this._onItemChange(selected)
                }}
              />
            </div>
          </Tooltip>
        </td>
        <td className="min-width-input">
          <Tooltip title={item.description ? item.description : ''}>
            <DebounceInput
              className="ant-input"
              minLength={0}
              debounceTimeout={500}
              value={item.description ? item.description : ''}
              onChange={event =>
                handleItemColumnChange(event, 'description', itemIndex, sectionIndex)
              }
              name="description"
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input">
          <Tooltip title={item.quantity ? item.quantity : ''}>
            <InputNumber
              min={-100}
              onChange={event => handleItemColumnChange(event, 'quantity', itemIndex, sectionIndex)}
              formatter={value => `${value}`}
              value={item.quantity}
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input">
          <Tooltip title={item.cost ? item.cost : ''}>
            <CurrencyInput
              className="ant-input"
              precision="2"
              prefix="$"
              allowNegative
              value={item.cost}
              onChange={event => handleItemColumnChange(event, 'cost', itemIndex, sectionIndex)}
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input">
          <Tooltip title={item.sub_total ? item.sub_total : ''}>
            <CurrencyInput
              className="ant-input-number-disabled ant-input"
              precision="2"
              prefix="$"
              allowNegative
              value={item.sub_total}
              disabled={'disabled'}
              onChange={event =>
                handleItemColumnChange(event, 'sub_total', itemIndex, sectionIndex)
              }
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input padding-r-20">
          <Tooltip title={this.getOverheadValue(item)}>
            <InputNumber
              min={0}
              step={0.1}
              precision={3}
              disabled={!item.remove_default_overhead}
              formatter={value => `${value || '0.000'}%`}
              parser={value => value.replace('%', '')}
              value={this.getOverheadValue(item)}
              name="overhead"
              onChange={event => handleItemColumnChange(event, 'overhead', itemIndex, sectionIndex)}
            />
          </Tooltip>
          <Tooltip title="Remove defaults">
            <Checkbox
              checked={item.remove_default_overhead}
              onChange={event =>
                handleItemColumnChange(event, 'remove_default_overhead', itemIndex, sectionIndex)
              }
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input padding-r-20 ">
          <Tooltip title={this.getMarkupValue(item)}>
            <InputNumber
              min={0}
              step={0.1}
              precision={3}
              formatter={value => `${value || '0.000'}%`}
              parser={value => value.replace('%', '')}
              name="markup"
              disabled={!item.remove_default_markup}
              value={this.getMarkupValue(item)}
              onChange={event => handleItemColumnChange(event, 'markup', itemIndex, sectionIndex)}
            />
          </Tooltip>
          <Tooltip title="Remove defaults">
            <Checkbox
              checked={item.remove_default_markup}
              onChange={event =>
                handleItemColumnChange(event, 'remove_default_markup', itemIndex, sectionIndex)
              }
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input padding-r-20">
          <Tooltip title={this.getTaxValue(item)}>
            <InputNumber
              min={0}
              max={100}
              step={0.1}
              precision={3}
              disabled={!item.remove_default_tax}
              formatter={value => `${value || '0.000'}%`}
              parser={value => value.replace('%', '')}
              value={this.getTaxValue(item)}
              onChange={event => handleItemColumnChange(event, 'tax', itemIndex, sectionIndex)}
            />
          </Tooltip>
          <Tooltip title="Remove defaults">
            <Checkbox
              checked={item.remove_default_tax}
              onChange={event =>
                handleItemColumnChange(event, 'remove_default_tax', itemIndex, sectionIndex)
              }
            />
          </Tooltip>
        </td>
        <td className="text-nowrap min-width-input">
          <Tooltip title={item.grand_total ? item.grand_total : ''}>
            <CurrencyInput
              className="ant-input"
              precision="2"
              prefix="$"
              value={item.grand_total}
              allowNegative
              disabled
              onChange={event =>
                handleItemColumnChange(event, 'grand_total', itemIndex, sectionIndex)
              }
            />
          </Tooltip>
        </td>
        <td className="text-right text-nowrap">
          <ButtonGroup>
            <Button
              type="primary"
              onClick={() => handleItemDown(itemIndex, sectionIndex)}
              icon="down"
            />
            <Button
              type="primary"
              onClick={() => handleItemUp(itemIndex, sectionIndex)}
              icon="up"
            />
            <Button
              type="danger"
              onClick={() => handleItemDelete(sectionIndex, itemIndex)}
              icon="delete"
            />
          </ButtonGroup>
        </td>
      </tr>
    )
  }
}

const mapStateToProps = ({ itemActions }, ownProps) => ({
  itemActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, itemActions), dispatch)
})

EstimateItem.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(EstimateItem)))



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateItem.js